import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql';

import NotificationsButtonQuery from './__generated__/NotificationsButtonQuery.graphql';

export const preloadUnseenNotificationCount = () => {
	return queryAgg({ query: NotificationsButtonQuery });
};
